export const PROFILE_TYPE_TABS = [
  { value: 'all', label: 'All' },
  { value: 'standard', label: 'Standard' },
  { value: 'custom', label: 'Custom' },
];

export const DEFAULT_PROFILE_FORM = {
  organisation: null,
  name: '',
  is_standard: false,
  sessionDays: 0,
  sessionHours: 0,
  sessionMinutes: 0,
};

export const DEFAULT_LIST_FILTERS = {
  search: '',
  page: 0,
  limit: 20,
  organisationId: '',
};

export const SESSION_DAY_OPTIONS = Array.from({ length: 32 }, (_, index) => ({
  value: index,
  label: `${index} Days`,
}));

export const SESSION_HOUR_OPTIONS = Array.from({ length: 24 }, (_, index) => ({
  value: index,
  label: `${index} Hours`,
}));

export const SESSION_MINUTE_OPTIONS = Array.from({ length: 60 }, (_, index) => ({
  value: index,
  label: `${index} Minutes`,
}));

export const PROFILE_DELETE_COPY = {
  confirmTitle: 'Delete Profile',
  blockedTitle: 'Cannot delete profile',
  confirmMessage: 'Are you sure you want to delete profile',
  confirmSuffix: 'This action cannot be undone.',
  blockedIntro: 'is assigned to',
  blockedSuffix: 'Reassign these users to another profile before deleting.',
  blockedNoUserAccess:
    'Reassign these users in User Management before deleting this profile.',
  guardLoading: 'Checking assigned users…',
  guardError: 'Unable to verify profile assignments. Delete is disabled until this check succeeds.',
  viewAssignedUsers: 'View assigned users',
  moreUsersLabel: (count) => `+${count} more`,
};

export const PROFILE_CLONE_COPY = {
  permissionsTitle: 'Permissions for new profile',
  permissionsDescription:
    'Permissions are copied from the source profile. Adjust them below before cloning if needed.',
  permissionsLoading: 'Loading permissions from source profile…',
  permissionsError:
    'Unable to load permissions. The profile will still be cloned with the source permissions.',
  permissionsEmpty: 'No permission modules are configured for this profile.',
  modifiedLabel: 'Modified',
};
